import { render, staticRenderFns } from "./DodCustomAddButton.vue?vue&type=template&id=3dbb43d3&scoped=true&"
import script from "./DodCustomAddButton.vue?vue&type=script&lang=js&"
export * from "./DodCustomAddButton.vue?vue&type=script&lang=js&"
import style0 from "./DodCustomAddButton.vue?vue&type=style&index=0&id=3dbb43d3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dbb43d3",
  null
  
)

export default component.exports